module.exports = __webpack_public_path__ + "static/media/heroku.8495e429.jpg";